/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClearIcon from "@mui/icons-material/Clear";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Select,
  InputLabel,
  Avatar,
  Chip,
  Button,
  OutlinedInput,
  Modal,
  Box,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import DocumentUpload from "../components/DocumentUpload";
import { RestartAlt, ZoomIn, ZoomOut } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
  cursor: pointer;
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

// ========== HELPERS ==========

// Fetch a single document blob and return object URL
const fetchDocumentBlob = async (docKey, authData) => {
  try {
    let u = "";
    if (authData?.type === "customer_user") {
      u = `/api/v1/${authData?.type}/${authData?.user_id}/media/${docKey}`;
    } else {
      u = `/api/v1/${authData?.type}/media/${docKey}`;
    }
    const response = await fetch(u, {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
      method: "GET",
    });
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (e) {
    console.error("Error fetching document:", e);
    return null;
  }
};

// Get all document URLs and set them in state
const loadAllDocuments = async (documents, authData, setUrls, setLoader) => {
  if (!documents || documents.length === 0) {
    setUrls([]);
    setLoader(false);
    return;
  }
  const urlPromises = documents.map(async (doc) => {
    const key = doc?.document_storage_info?.key || "";
    const type = key.split(".").pop().toLowerCase();
    const blobUrl = await fetchDocumentBlob(key, authData);
    return {
      url: blobUrl,
      name: doc.document_title,
      type: type,
      key: key,
    };
  });
  const results = await Promise.all(urlPromises);
  setUrls(results.filter(item => item.url !== null));
  setLoader(false);
};

// Get user details (used for refresh)
const getDetails = async (setDetails, setLoader, setUrls) => {
  const userData = JSON.parse(localStorage.getItem("AuthData"));
  const config = {
    headers: {
      Authorization: "Bearer " + userData.access_token,
    },
  };
  let url = "";
  if (userData.type === "super_admin") {
    url = `/api/v1/super_admin/my`;
  } else if (userData.type === "ap_user") {
    url = `/api/v1/ap_user/${userData.user_id}/my`;
  } else if (userData.type === "customer_user") {
    url = `/api/v1/customer_user/${userData.user_id}/my`;
  }
  const { data } = await axios.get(url, config);
  setDetails(data.data);
  setLoader(false);
  // Load documents after getting details
  if (data.data?.documents) {
    loadAllDocuments(data.data.documents, userData, setUrls, setLoader);
  }
};

// ========== MAIN COMPONENT ==========
function DefaultTextFields() {
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const navigate = useNavigate();

  // ---------- state ----------
  const [details, setDetails] = useState({});
  const [loader, setLoader] = useState(true);
  const [urls, setUrls] = useState([]);
  const [profileLoader, setProfileLoader] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [imgValue, setImgVal] = useState(null);
  const inputFile = useRef(null);

  // ---------- edit mode states ----------
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email_address: "",
    phone_number: "",
    address_line_one: "",
    address_line_two: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [openAddDoc, setOpenAdddoc] = useState(false);
  const [images, setImages] = useState({});
  const [documents, setDocuments] = useState({});
  const [del, setDelete] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewType, setPreviewType] = useState("");
  const [modalImgHeight, setModalImgHeight] = useState(70);

  const handleClosePreview = () => setPreviewOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // ---------- fetch data on mount ----------
  useEffect(() => {
    getDetails(setDetails, setLoader, setUrls);
  }, []);

  // ---------- populate formData when details load ----------
  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      setFormData({
        name: details?.name || "",
        email_address: details?.email_address || "",
        phone_number: details?.phone_number || "",
        address_line_one: details?.address_line_one || "",
        address_line_two: details?.address_line_two || "",
        city: details?.city || "",
        state: details?.state || "",
        pincode: details?.pincode || "",
      });
    }
  }, [details]);

  // ---------- reset form to current details ----------
  const resetForm = () => {
    setFormData({
      name: details?.name || "",
      email_address: details?.email_address || "",
      phone_number: details?.phone_number || "",
      address_line_one: details?.address_line_one || "",
      address_line_two: details?.address_line_two || "",
      city: details?.city || "",
      state: details?.state || "",
      pincode: details?.pincode || "",
    });
  };

  // ---------- detect profile picture ----------
  useEffect(() => {
    const pf = urls.find((item) => item.name === "profile_picture");
    setProfilePic(pf ? pf.url : "");
  }, [urls]);

  // ---------- profile picture upload handlers ----------
  const onButtonClick = () => inputFile.current.click();

  const handleProfileChange = async () => {
    try {
      setProfileLoader(true);
      const formDt = new FormData();
      formDt.set("profile_picture", imgValue);

      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      let uploadUrl = "";
      if (authData?.type === "ap_user") {
        uploadUrl = `/api/v1/ap_user/media/ap_user/${authData.user_id}`;
      } else if (authData?.type === "customer_user") {
        uploadUrl = `/api/v1/customer_user/media/ap_user/${authData.user_id}`;
      } else {
        uploadUrl = `/api/v1/super_admin/media/ap_user/${authData.user_id}`;
      }

      const { data } = await axios.post(uploadUrl, formDt, config);
      if (data.success) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Profile picture updated successfully",
        });
        // Refresh user data
        getDetails(setDetails, setLoader, setUrls);
      }
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: e.response?.data?.error || "Upload failed",
      });
    } finally {
      setProfileLoader(false);
    }
  };

  // ---------- profile update (inline edit) ----------
  const handleProfileUpdate = async () => {
    try {
      setLoader(true);

      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      let updateUrl = "";
      if (authData.type === "ap_user") {
        updateUrl = `/api/v1/ap_user/ops/${authData.user_id}`;
      } else if (authData.type === "customer_user") {
        updateUrl = `/api/v1/customer_user/ops/${authData.user_id}`;
      } else {
        // super_admin may not have an update endpoint; handle gracefully
        setSnackbar({
          open: true,
          severity: "error",
          message: "Super Admin profile cannot be edited here",
        });
        setLoader(false);
        return;
      }

      const { data } = await axios.put(updateUrl, formData, config);

      if (data.success) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Profile updated successfully",
        });

        setIsEditing(false);

        // Refresh data
        getDetails(setDetails, setLoader, setUrls);
      }
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: e.response?.data?.error || "Update failed",
      });
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  // ---------- document management ----------
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
    setImages({});
    setDocuments({});
  };
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };

  const addDocuments = async () => {
    try {
      // Validate that all images have a name
      let br = 0;
      Object.values(images).forEach((doc, i) => {
        if (!documents[i]) {
          setSnackbar({
            open: true,
            severity: "error",
            message: "Document Name field cannot be empty",
          });
          br = 1;
          return;
        }
      });
      if (br) return;

      setLoader(true);
      const formDataDoc = new FormData();
      Object.values(images).forEach((image, i) => {
        formDataDoc.set(`document_${i + 1}_file`, image);
      });
      Object.values(documents).forEach((doc, i) => {
        formDataDoc.set(`document_${i + 1}_name`, doc);
      });

      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      let uploadUrl = "";
      if (authData?.type === "ap_user") {
        uploadUrl = `/api/v1/ap_user/media/ap_user/${authData.user_id}`;
      } else if (authData?.type === "customer_user") {
        uploadUrl = `/api/v1/customer_user/media/ap_user/${authData.user_id}`;
      } else {
        uploadUrl = `/api/v1/super_admin/media/ap_user/${authData.user_id}`;
      }

      const { data } = await axios.post(uploadUrl, formDataDoc, config);
      setSnackbar({
        open: true,
        severity: "success",
        message: "Documents Added Successfully",
      });
      handleDownDoc();
      // Refresh user data
      getDetails(setDetails, setLoader, setUrls);
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: e.response?.data?.error || "Add failed",
      });
      setLoader(false);
    }
  };

  const deleteDocument = async (key) => {
    try {
      setLoader(true);
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let deleteUrl = "";
      if (authData?.type === "ap_user") {
        deleteUrl = `/api/v1/ap_user/media/ap_user/${authData.user_id}/${key}`;
      } else if (authData?.type === "customer_user") {
        deleteUrl = `/api/v1/customer_user/media/ap_user/${authData.user_id}/${key}`;
      } else {
        deleteUrl = `/api/v1/super_admin/media/ap_user/${authData.user_id}/${key}`;
      }
      const { data } = await axios.delete(deleteUrl, config);
      setSnackbar({
        open: true,
        severity: "success",
        message: "Document Deleted successfully",
      });
      // Refresh user data
      getDetails(setDetails, setLoader, setUrls);
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: e.response?.data?.error || "Delete failed",
      });
      setLoader(false);
    }
  };

  // ---------- render ----------
  if (loader) return <Loading />;

  return (
    <>
      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        autoHideDuration={6000}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <form>
        <Card mb={6}>
          <CardContent>
            <Paper elevation={3} style={{ padding: "2%" }}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Typography variant="h4" gutterBottom>
                    My Profile
                  </Typography>
                </Grid>

                {/* Profile Picture */}
                <Grid item xs={12}>
                  <BigAvatar
                    src={profilePic || "/static/img/avatars/icon.png"}
                    onClick={onButtonClick}
                  />
                  <input
                    type="file"
                    ref={inputFile}
                    accept=".png,.jpg,.jpeg"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        setProfilePic(URL.createObjectURL(e.target.files[0]));
                        setImgVal(e.target.files[0]);
                      }
                    }}
                  />
                  <Typography align="center">
                    <Button
                      variant="outlined"
                      onClick={handleProfileChange}
                      disabled={!imgValue || profileLoader}
                    >
                      {profileLoader ? "Updating..." : "Update Profile Picture"}
                    </Button>
                  </Typography>
                </Grid>

                {/* Editable fields */}
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Name"
                    value={formData.name}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Email Address"
                    value={formData.email_address}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        email_address: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Phone Number"
                    value={formData.phone_number}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone_number: e.target.value,
                      }))
                    }
                  />
                </Grid>
                {details?.role && (
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      id="standard-required"
                      value={details.role.role_name}
                      inputProps={{ readOnly: true }}
                      label="Role"
                    />
                  </Grid>
                )}
                {details?.ap_company && details.ap_company.length > 0 && (
                  <Grid item xs={12} lg={12} md={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-mutiple-chip-label">
                        Alpha Plus Companies
                      </InputLabel>
                      <Select
                        variant="outlined"
                        labelId="demo-mutiple-chip-label"
                        value={details.ap_company}
                        id="demo-mutiple-chip"
                        inputProps={{ readOnly: "true" }}
                        multiple
                        input={
                          <OutlinedInput
                            id="select-multiple-chip"
                            variant="contained"
                            label="Alpha Plus Companies"
                          />
                        }
                        renderValue={(selected) => (
                          <div>
                            {selected.map((value) => (
                              <Chip key={value.name} label={value.name} />
                            ))}
                          </div>
                        )}
                        MenuProps={MenuProps}
                      />
                    </FormControl>
                  </Grid>
                )}
                {details?.customer_company && (
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      id="standard-required"
                      value={details.customer_company.name}
                      inputProps={{ readOnly: true }}
                      label="Customer Company"
                    />
                  </Grid>
                )}
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Address Line One"
                    value={formData.address_line_one}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        address_line_one: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Address Line Two"
                    value={formData.address_line_two}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        address_line_two: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="City"
                    value={formData.city}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="State"
                    value={formData.state}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        state: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-required"
                    label="Pincode"
                    value={formData.pincode}
                    disabled={!isEditing}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        pincode: e.target.value,
                      }))
                    }
                  />
                </Grid>
              </Grid>

              {/* Edit / Cancel / Save buttons */}
              <Grid item xs={12} md={12} lg={12} style={{ marginTop: 16 }}>
                {!isEditing ? (
                  <Button
                    variant="contained"
                    onClick={() => setIsEditing(true)}
                    disabled={authData?.type === "super_admin"} // optional: disable for super_admin
                  >
                    Edit Profile
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleProfileUpdate}
                      style={{ marginRight: 16 }}
                    >
                      Save Changes
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setIsEditing(false);
                        resetForm();
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </Grid>
            </Paper>
          </CardContent>
        </Card>

        {/* Document List */}
        {authData?.type === 'ap_user' && <Card mb={6}>
          <CardContent>
            <Paper elevation={3} style={{ padding: "2%" }}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Typography variant="h4" gutterBottom>
                    My Documents
                  </Typography>
                </Grid>
              </Grid>

              {!urls.length ? (
                <Grid item xs={12}>
                  <Typography variant="h6" color="primary" gutterBottom>
                    No Documents Added
                  </Typography>
                </Grid>
              ) : null}

              {urls.map((item, index) => {
                if (item.name === "profile_picture") return null;
                return (
                  <Paper
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                    mt={3}
                  >
                    <Box
                      component="img"
                      width="90px"
                      height="80px"
                      onClick={() => handleOpenPreview(item.url, item.type)}
                      src={
                        item.type === "pdf"
                          ? "/static/img/images/pdf.png"
                          : item.url
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <TextField
                      fullWidth
                      margin="dense"
                      m={2}
                      style={{ marginLeft: 32 }}
                      inputProps={{ readOnly: true }}
                      id="standard-required"
                      label="Document Name"
                      value={item.name || ""}
                    />
                    {!del ? (
                      <Mob>
                        <Grid item>
                          <a
                            href={item.url}
                            style={{
                              color: "inherit",
                              textDecoration: "inherit",
                            }}
                            download={`${item.name}.${item.type}`}
                          >
                            <FileDownloadIcon
                              style={{ marginLeft: 32, cursor: "pointer" }}
                            />
                          </a>
                        </Grid>
                      </Mob>
                    ) : (
                      <Grid item>
                        <ClearIcon
                          onClick={() => deleteDocument(item.key)}
                          style={{ marginLeft: 32, cursor: "pointer" }}
                        />
                      </Grid>
                    )}
                  </Paper>
                );
              })}

              {/* Add / Delete buttons */}
              {!del ? (
                <Grid item xs={12} style={{ marginTop: 16 }}>
                  <Button
                    onClick={handleOpenDoc}
                    variant="contained"
                    color="primary"
                  >
                    Add Document
                  </Button>
                  <Button
                    onClick={() => setDelete(true)}
                    style={{ color: "red", marginLeft: 16 }}
                  >
                    Delete Document
                  </Button>
                </Grid>
              ) : (
                <Grid item xs={12} style={{ marginTop: 16 }}>
                  <Button onClick={() => setDelete(false)} variant="outlined">
                    Cancel
                  </Button>
                </Grid>
              )}
            </Paper>
          </CardContent>
        </Card>}
      </form>

      {/* Document Preview Modal */}
      <Modal open={previewOpen} onClose={handleClosePreview}>
        <Card sx={style}>
          <CardContent>
            <Paper>
              <Grid container justifyContent="center" spacing={5}>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <IconButton
                    onClick={() => setModalImgHeight(modalImgHeight + 5)}
                  >
                    <ZoomIn />
                  </IconButton>
                  <IconButton
                    onClick={() => setModalImgHeight(modalImgHeight - 5)}
                  >
                    <ZoomOut />
                  </IconButton>
                  <IconButton onClick={() => setModalImgHeight(70)}>
                    <RestartAlt />
                  </IconButton>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    maxHeight: "72.5vh",
                    overflowY: "scroll",
                  }}
                >
                  {previewType !== "pdf" ? (
                    <Box
                      component="img"
                      src={previewUrl}
                      height={modalImgHeight.toString() + "vh"}
                      width="auto"
                    />
                  ) : (
                    <iframe
                      height={(modalImgHeight + 420).toString() + "vh"}
                      width={(modalImgHeight + 420).toString() + "vh"}
                      src={previewUrl}
                      title="Document Preview"
                    />
                  )}
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>

      {/* Add Document Modal */}
      <Modal
        open={openAddDoc}
        onClose={handleDownDoc}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            align="center"
            color="primary"
          >
            Add Documents
          </Typography>
          <DocumentUpload
            documents={documents}
            setDocuments={setDocuments}
            images={images}
            setImages={setImages}
          />
          <Button onClick={addDocuments}>Add</Button>
        </Box>
      </Modal>
    </>
  );
}

// ========== PARENT COMPONENT ==========
function MyProfile() {
  return (
    <React.Fragment>
      <Helmet title="Alpha Plus" />
      <Grid
        justifyContent="space-between"
        alignItems="center"
        container
        spacing={10}
        mb={4}
      >
        <Grid item>
          <Typography
            variant="h4"
            gutterBottom
            display="inline"
            sx={{ fontWeight: 600 }}
            color="primary"
          >
            MY PROFILE
          </Typography>
        </Grid>
        <Grid item>
          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/dashboard/tasks">
              Dashboard
            </Link>
            <Typography>My Profile</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <DefaultTextFields />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default MyProfile;